module.exports = __webpack_public_path__ + "img/savva2.19718e6.jpg";